import { environment } from '../../../environments/environment';

export const getServerUrl = function(gameId: string): string {
  const gamePrefixes = {
    T: 'triviaBaseUrl',
    P: 'telestrationsBaseUrl',
    L: 'liarsDiceBaseUrl',
    S: 'scattergoriesBaseUrl'
  };

  if (gameId && gameId.length > 0) {
    const gamePrefix = gameId[0];

    return environment[gamePrefixes[gamePrefix]] || environment.triviaBaseUrl;
  }
};

export function randomizeArray(choices: any[]) {
  return choices.sort(function(a, b) {
    const number1 = Math.random();
    const number2 = Math.random();

    if (number1 < number2) {
      return -1;
    }

    return 1;
  });
}
